import React from "react";
import { Helmet } from "react-helmet-async";
import Heading from "../components/common/Heading";
import Sliders from "../components/home/Testimonial";
import QuickFacts from "../components/common/QuickFacts";

export default function Testimonial() {
  return (
    <>
      <Helmet>
        <title>Guest Reviews & Testimonials | HariKunj Resort Jodhpur</title>
        <meta
          name="description"
          content="Read authentic verified testimonials from families, solo travelers, and couples who experienced the royal hospitality and comfort of HariKunj Resort in Jodhpur, Rajasthan."
        />
        <link rel="canonical" href="https://harikunjresort.com/testimonials" />
        <meta property="og:title" content="Guest Reviews & Testimonials | HariKunj Resort Jodhpur" />
        <meta property="og:description" content="Read authentic verified testimonials from families, solo travelers, and couples who experienced the royal hospitality and comfort of HariKunj Resort in Jodhpur, Rajasthan." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://harikunjresort.com/testimonials" />
        <meta property="og:image" content="https://harikunjresort.com/assets/img/testimonial-1.webp" />
      </Helmet>

      <Heading heading="Guest Testimonials" title="Home" subtitle="Testimonials" />

      <h1 className="visually-hidden">
        Verified Guest Reviews &amp; Ratings — HariKunj Resort Jodhpur
      </h1>

      <Sliders />
      <QuickFacts pageTitle="Guest Reviews" />
    </>
  );
}
